// Constants/RestaurantEdit.js
export const FORM_RESTAURANT_EDIT = {
  name: "",
  categoriaPrincipal: "",   // 👈 nueva propiedad
  categorias: [],
  tiempoEntregaEstimado: 30,
  costoEnvio: 35,
  phone: "",
  email: "",
  horarios: [],
};
